var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 24,
    cy: 24.3193,
    r: 23.5,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0039 13.252C18.0668 13.252 13.2539 18.0649 13.2539 24.002C13.2539 29.9391 18.0668 34.752 24.0039 34.752C29.941 34.752 34.7539 29.9391 34.7539 24.002C34.7539 18.0649 29.941 13.252 24.0039 13.252ZM23.9985 20.002C22.3007 20.002 20.7259 20.5594 19.418 21.5052C18.9705 21.8288 18.87 22.454 19.1937 22.9015C19.5173 23.3491 20.1424 23.4495 20.59 23.1259C21.5798 22.4101 22.749 22.002 23.9985 22.002C25.252 22.002 26.4247 22.4127 27.4165 23.1327C27.8634 23.4571 28.4888 23.3578 28.8132 22.9109C29.1377 22.464 29.0384 21.8386 28.5914 21.5141C27.2812 20.563 25.7018 20.002 23.9985 20.002ZM23.9985 23.4337C23.0427 23.4337 22.1407 23.6828 21.3461 24.1207C20.8624 24.3873 20.6864 24.9955 20.953 25.4792C21.2195 25.9629 21.8278 26.1389 22.3114 25.8723C22.8241 25.5898 23.3956 25.4337 23.9985 25.4337C24.6045 25.4337 25.1788 25.5913 25.6934 25.8766C26.1765 26.1444 26.7851 25.9698 27.0529 25.4868C27.3206 25.0038 27.1461 24.3951 26.663 24.1274C25.8655 23.6853 24.9593 23.4337 23.9985 23.4337ZM24.0008 27.002C23.4503 27.002 23.004 27.4497 23.004 28.002C23.004 28.5543 23.4503 29.002 24.0008 29.002C24.5478 29.002 25.004 28.5507 25.004 28.002C25.004 27.4533 24.5478 27.002 24.0008 27.002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.841b3827800c0bc089f2dd65fe02c820.svg";
export { ForwardRef as ReactComponent };